// modalReducer.js
import { createSlice } from '@reduxjs/toolkit';

const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    isVisible: false,
    error: null,
  },
  reducers: {
    openModal(state,action) {
      state.isVisible = true;
      state.error = null; // Reset error when opening modal
    },
    closeModal(state,action) {
      state.isVisible = false;
      state.error = null; // Reset error when closing modal
    },
    setError(state, action) {
      state.error = action.payload;
    },
  },
});


export const { openModal, closeModal, setError } = modalSlice.actions;
export const modalReducer = modalSlice.reducer;